import type { CustomRequestOptions } from '@/interceptors/request'
import { Sign } from '@/interceptors/signAuth'
import { logHttpError } from '@/utils/httpHelper'
import { ShowMessage } from '@/utils/request/enum'

export async function loginAuth<T>(options: CustomRequestOptions) {
  // 边缘计算签名
  Sign.signAuth(options)

  // 1. 返回 Promise 对象
  return new Promise<T>((resolve, reject) => {
    uni.request({
      ...options,
      dataType: 'json',
      // #ifndef MP-WEIXIN
      responseType: 'json',
      // #endif
      // 响应成功
      success(res) {
        // 状态码 2xx，参考 axios 的设计
        if (res.statusCode >= 200 && res.statusCode < 300) {
          // 2.1 提取核心数据 res.data
          resolve(res.data as T)
        }
        else {
          logHttpError(options, res.data ?? res, {
            message: ShowMessage(res.statusCode),
            statusCode: res.statusCode,
          }, 'loginAuth request error')
          // 其他错误 -> 根据后端错误信息轻提示
          !options.hideErrorToast
          && uni.showToast({
            icon: 'none',
            title: ShowMessage(res.statusCode),
          })
          reject(res)
        }
      },
      // 响应失败
      fail(err) {
        logHttpError(options, err, {
          message: err.errMsg,
          statusCode: 404,
        }, 'loginAuth request error')
        uni.showToast({
          icon: 'none',
          title: '网络错误，换个网络试试',
        })
        reject(err)
      },
    })
  })
}

/**
 * GET 请求
 * @param url 后台地址
 * @param query 请求query参数
 * @param header 请求头，默认为json格式
 * @returns
 */
export function loginAuthGet<T>(url: string, query?: Record<string, any>, header?: Record<string, any>, options?: Partial<CustomRequestOptions>) {
  return loginAuth<T>({
    url,
    query,
    method: 'GET',
    header,
    ...options,
  })
}

/**
 * POST 请求
 * @param url 后台地址
 * @param data 请求body参数
 * @param query 请求query参数，post请求也支持query，很多微信接口都需要
 * @param header 请求头，默认为json格式
 * @returns
 */
export function loginAuthPost<T>(url: string, data?: Record<string, any>, query?: Record<string, any>, header?: Record<string, any>, options?: Partial<CustomRequestOptions>) {
  return loginAuth<T>({
    url,
    query,
    data,
    method: 'POST',
    header,
    ...options,
  })
}
/**
 * PUT 请求
 */
export function loginAuthPut<T>(url: string, data?: Record<string, any>, query?: Record<string, any>, header?: Record<string, any>, options?: Partial<CustomRequestOptions>) {
  return loginAuth<T>({
    url,
    data,
    query,
    method: 'PUT',
    header,
    ...options,
  })
}

/**
 * DELETE 请求（无请求体，仅 query）
 */
export function loginAuthDelete<T>(url: string, query?: Record<string, any>, header?: Record<string, any>, options?: Partial<CustomRequestOptions>) {
  return loginAuth<T>({
    url,
    query,
    method: 'DELETE',
    header,
    ...options,
  })
}

loginAuth.get = loginAuthGet
loginAuth.post = loginAuthPost
loginAuth.put = loginAuthPut
loginAuth.delete = loginAuthDelete
